/**
 * Maps risk factor keys to their corresponding permission names
 */
export const RISK_FACTOR_PERMISSIONS: Record<string, string> = {
  actingownaccount: 'view_actingownaccount',
  countryofbirth: 'view_countrybirthrisk',
  countryofcitizenship: 'view_countrycitizenshiprisk',
  countryofresidence: 'view_countryresidencerisk',
  expectedannualinvestment: 'view_expectedannualinvestment',
  occupation: 'view_occupationrisk',
  pep: 'view_pepstatus',
  purposeofaccount: 'view_purposeofaccount',
  sanctions: 'view_sanctionsrisk',
  sourceoffunds: 'view_proofoffunds',
  watchlist: 'view_watchlistrisk'
};
